<template>
  <div>
    <c-q-separator class="q-pb-lg" />

    <div id="div-pesquisa-campanha" class="row q-pb-lg">      
      <div class="q-pb-xs">
        <span class="midia-app-label-lg">Pesquise um Cadastro de Telas Institucionais</span>
      </div>

      <div class="row fit no-wrap justify-between items-end content-start">
        <div class="col-grow" style=" overflow: auto; ">
          <q-input
            id="searchbar"
            style=" position: relative; "
            v-model="filterTerms"
             @update:model-value="onSearchInput"
            color="globalAppPrimaryColor"
            bg-color="globalAppDefaultBackgroundColor"
            outlined
            dense
            placeholder="Consulte um Cadastro de Telas"
            input-class="midia-app-content-lg"
          >
            <template v-slot:prepend>
              <q-icon
                name="search"
                class="q-pa-sm"
                style=" background: var(--globalAppSecondaryColor4); padding: 6px; position: relative; left: -11px; border-right: 1px solid var(--globalAppSecondaryColor2); "
              />
            </template>

            <template v-slot:append>
              <div>
                <div style= "position: relative; ">
                  <q-btn
                    id="btn-show-filterbox"
                    unelevated
                    color="globalAppDefaultBackgroundColor"
                    text-color="globalAppDefaultTextColor"
                    outlined
                    no-caps
                    @click="onFilterBtnClick()"
                  >
                    <template v-slot:default>
                      <q-icon size="16px">
                        <img class="svg-icon" src="@/assets/icons/icon_filter.svg" />
                      </q-icon>

                      <span class="midia-app-label-lg q-pl-sm">Filtrar</span>
                      <!-- <span class="midia-app-label-lg q-pl-sm" :style="(isFilterActive ? ' color: var(--globalAppPrimaryColor) !important; font-style: italic !important; ' : '')">Filtrar</span> -->
                    </template>
                  </q-btn>
                </div>
              </div>
            </template>
          </q-input>
        </div>

        <div class="q-pl-md" style=" overflow: auto; ">
          <c-q-btn
            v-if="authStore.currentUserCanCreateInstitutional"
            id="btn-new-campaign"
            propBtnLabel="Novo Cadastro"
            :propBtnFunction="onNewInstitutionalBtnClick"
            :propBtnTransparent="true"
            :propBtnSize="EnumButtonSizes.LARGE_1"
          >
            <template v-slot:default>
              <q-icon size="16px" class="q-pr-sm">
                <img class="svg-icon" src="@/assets/icons/icon_perfil_red.svg" />
              </q-icon>
            </template>
          </c-q-btn>
        </div>
      </div>
    </div>

    <span class="midia-app-label-sm">Cadastros encontrados</span>

    <div id="div-table-campanha" class="row justify-center q-gutter-sm">
      <div style=" width: 100%; ">
        <q-table
          ref="qTableCampanhas"
          :rows="fetchedInstitutionalsFiltered"
          row-key="id"
          :columns="qTableCampanhasColumns"
          :visible-columns="qTableCampanhasVisibleColumns"
          v-model:pagination="pagination"
          :rows-per-page-options="[5, 10, 25, 50, 100]"
          :hide-pagination="true"
          no-data-label="Nenhum registro encontrado!"
          rows-per-page-label="Linhas por página:"
          selection="multiple"
          v-model:selected="institutionalStore.selectedInstitutionals"
          :dense="$q.screen.lt.md"
          flat
          separator="horizontal"
          class="midia-app-table"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th
                style="
                  background: var(--globalAppSecondaryColor4);
                  text-align: center;
                  border: 0;
                "
                :auto-width="true"
              >
                <q-checkbox
                  v-model="props.selected"
                  :color="(props.selected ? 'globalAppPrimaryColor' : 'globalAppSecondaryColor2')"
                  :keep-color="(!props.selected)"
                />
              </q-th>
              
              <q-th
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
                style="
                  background: var(--globalAppSecondaryColor4);
                  border: 0;
                "
              >
                <span class="midia-app-title-header-table-lg">{{ col.label }}</span>
              </q-th>
            </q-tr>
          </template>

          <template v-slot:body="props">
            <q-tr class="table-body-rows" :props="props">
              <q-td key="selected" style=" text-align: center; " :auto-width="true">
                <q-checkbox
                  v-model="props.selected"
                  :color="(props.selected ? 'globalAppPrimaryColor' : 'globalAppSecondaryColor2')"
                  :keep-color="(!props.selected)"
                />
              </q-td>

              <!-- <q-td key="id" :props="props">
                <div class="row items-center">
                  <span class="midia-app-label-lg">{{ props.row.id }}</span>
                </div>
              </q-td> -->

              <q-td key="advertiser" :props="props">
                <div class="row items-center no-wrap">
                  <q-icon size="24px">
                    <img class="svg-icon" src="@/assets/icons/icon_advertiser_HiOutlineSpeakerphone.svg" />
                  </q-icon>

                  <span class="midia-app-label-lg q-pl-md">{{ props.row.nome }}</span>
                </div>
              </q-td>

              <q-td key="name" :props="props">
                <div class="row items-center">
                  <span class="midia-app-label-lg">{{ props.row.perfil }}</span>
                </div>
              </q-td>

              <q-td key="format" :props="props">
                <div class="row items-center">
                  <span class="midia-app-label-lg">{{ formatTelasCadastradas(props.row.telasCadastradas) }}</span>
                </div>
              </q-td>

              <q-td key="startDate" :props="props">
                <div class="row items-center">
                  <span class="midia-app-label-lg">{{ formatDateBr(props.row.dtIniVigencia) }}</span>
                </div>
              </q-td>

              <q-td key="endDate" :props="props">
                <div class="row items-center">
                  <span class="midia-app-label-lg">{{ formatDateBr(props.row.dtFimVigencia) }}</span>
                </div>
              </q-td>

              <q-td key="status" :props="props">
                <div class="row items-center">
                  <!-- <span :class="'midia-app-label-lg ' + statusTextCssClass(props.row.status)">{{ props.row.status }}</span> -->
                  <span :class="'midia-app-label-lg ' + statusTextCssClass(props.row.status)">{{ getStatusLabel(props.row.status) }}</span>
                </div>
              </q-td>

              <q-td key="statusIcon" :props="props">
                <div class="row items-center justify-center">
                  <q-icon size="24px">
                    <img v-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.APPROVED.id)"                   class="svg-icon" src="@/assets/icons/status/icon_status_approved_Vector.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id)"           class="svg-icon" src="@/assets/icons/status/icon_status_approving_HiClock.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.CANCELED.id)"              class="svg-icon" src="@/assets/icons/status/icon_status_canceled_HiXCircle.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_requested_adjustments_HiExclamation.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.ON_EDITING.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_edit.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.DRAFT.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_rascunho.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.PUBLISHED.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_published.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_edit.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_approving_HiClock.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_requested_adjustments_HiExclamation.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.REAPPROVED.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_approved_Vector.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_completed.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_active.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_pending_publication.svg" />
                    <img v-else-if="(props.row.status == CONST_INSTITUTIONAL_STATUS.HISTORICO.id)"  class="svg-icon" src="@/assets/icons/status/icon_status_historico.svg" />
                  
                  
                  </q-icon>
                </div>
              </q-td>

              <q-td>
                <div class="div-container-action-icons">
                  <div>
                    <q-btn
                      unelevated
                      color="white"
                      outlined
                      text-color="black"
                      no-caps
                    >
                    
                      <template v-slot:default>
                        <q-icon size="24px" @click="onActionsBtnClick(props.row)">
                          <img class="svg-icon" src="@/assets/icons/icon_IoEllipsisVerticalCircleOutline.svg" />
                        </q-icon>
                        <q-popup-proxy>
                          <q-banner>
                            <q-card style=" width: 127px; padding: 8px; ">
                              <div style=" display: flex; flex-direction: column; gap: 10px; ">
                                <BtnViewFocusedInstitutional
                                  style="width: 100%;"
                                  :id="props.row.id"
                                  :propBtnSize="EnumButtonSizes.SMALL"
                                />

                                <BtnEditFocusedInstitutional
                                  v-if="canEditInstitutional(props.row)"
                                  style="width: 100%;"
                                  :id="props.row.id"
                                  :propBtnSize="EnumButtonSizes.SMALL"
                                />

                                <BtnDeleteFocusedInstitutional
  v-if="canDeleteInstitutional(props.row)"
  style="width: 100%;"
  :propBtnSize="EnumButtonSizes.SMALL"
  :propInstitutionalId="props.row.id"
/>
                              </div>
                            </q-card>
                            
                          </q-banner>
                        </q-popup-proxy>
                      </template>
                    </q-btn>
                  </div>
                </div>
              </q-td>
            </q-tr>
          </template>

          <template #bottom>
            <div class="row full-width items-center justify-end q-pa-sm q-gutter-sm">

              <span class="midia-app-label-sm">Linhas por página:</span>
              <q-select
                v-model="pagination.rowsPerPage"
                :options="[5, 10, 25, 50, 100]"
                dense outlined
                style="width: 70px"
                @update:model-value="pagination.page = 1"
              />

              <span class="midia-app-label-sm">
                {{ (pagination.page - 1) * pagination.rowsPerPage + 1 }}-{{ Math.min(pagination.page * pagination.rowsPerPage, fetchedInstitutionalsFiltered.length) }}
                de {{ fetchedInstitutionalsFiltered.length }}
              </span>

              <q-btn flat dense round icon="first_page"
                :disable="pagination.page === 1"
                @click="pagination.page = 1"
              />
              <q-btn flat dense round icon="chevron_left"
                :disable="pagination.page === 1"
                @click="pagination.page--"
              />
              <q-btn flat dense round icon="chevron_right"
                :disable="pagination.page * pagination.rowsPerPage >= fetchedInstitutionalsFiltered.length"
                @click="pagination.page++"
              />
              <q-btn flat dense round icon="last_page"
                :disable="pagination.page * pagination.rowsPerPage >= fetchedInstitutionalsFiltered.length"
                @click="pagination.page = Math.ceil(fetchedInstitutionalsFiltered.length / pagination.rowsPerPage)"
              />
            </div>
          </template>

        </q-table>
      </div>
    </div>

    <c-q-separator class="q-my-md" />


<div class="row justify-end q-my-md">
  <BtnDeleteSelectedInstitutional />
</div>


   <!-- <ModalPageCampaignsTableActions
      :propShowBtnViewFocusedCampaign="showBtnViewFocusedCampaign"
      :propShowBtnEditFocusedCampaign="showBtnEditFocusedCampaign"
      :propShowBtnDeleteFocusedCampaign="showBtnDeleteFocusedCampaign"
    /> -->
    
    <ModalDeleteInstitutionalConfirmation />
    <ModalFilterInstitutional />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useQuasar } from 'quasar';
import { useRouter } from 'vue-router';

import { EnumRouteNames, EnumButtonSizes } from '@/enums/enums';
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional';

import { useInstitutionalStore } from '@/stores/institutionalStore';
import { usePagesUtilStore } from '@/stores/pagesUtilStore';
import { useAuthStore } from '@/stores/authStore';

import BtnViewFocusedInstitutional from '@/components/telasInstitucionais/actionButtons/BtnViewFocusedInstitutional.vue';
import BtnDeleteFocusedInstitutional from '@/components/telasInstitucionais/actionButtons/BtnDeleteFocusedInstitutional.vue';
import BtnEditFocusedInstitutional from '@/components/telasInstitucionais/actionButtons/BtnEditFocusedInstitutional.vue'

import ModalFilterInstitutional from '@/views/layout/modalsInstitutional/ModalFilterInstitutional.vue';
import ModalDeleteInstitutionalConfirmation from '@/views/layout/modalsInstitutional/ModalDeleteInstitutionalConfirmation.vue';
import BtnDeleteSelectedInstitutional from '@/components/telasInstitucionais/actionButtons/BtnDeleteSelectedInstitutional.vue' // ✅


import ModalPageCampaignsTableActions
  from '@/views/modals/ModalPageCampaignsTableActions.vue';

import type { InstitutionalScreen } from '@/stores/institutionalStore';

const showBtnViewFocusedCampaign = computed(() => true);
const showBtnDeleteFocusedCampaign = computed(() => true);

const formatDateBr = (date: string) => {
  if (!date) return '-'

  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

const onActionsBtnClick = (row: any) => {
  // Nenhuma ação necessária aqui por enquanto.
  // O q-popup-proxy cuida de abrir o menu.
};

const institutionalStore = useInstitutionalStore();
const pagesUtilStore = usePagesUtilStore();
const authStore = useAuthStore();

const $q = useQuasar();
const router = useRouter();

/* =====================
 * STATE
 * ===================== */
const filterTerms = ref('')
let searchTimeout: ReturnType<typeof setTimeout> | null = null

/* =====================
 * SEARCH
 * ===================== */
const onSearchInput = async (value: string) => {
  // ✅ debounce para não chamar a cada tecla
  if (searchTimeout) clearTimeout(searchTimeout)

  searchTimeout = setTimeout(async () => {
    if (value) {
      // ✅ busca no backend com o termo
      institutionalStore.institutionalFilter = { nome: value }
    } else {
      // ✅ sem termo → volta para os 10 mais recentes
      institutionalStore.resetInstitutionalFilter()
    }
    await institutionalStore.fetchInstitutionalScreens()
  }, 400)
}



/* =====================
 * TABLE
 * ===================== */
const qTableCampanhasColumns = [
  { name: 'advertiser', label: 'Cadastro de Telas', field: row => row.nome, align: 'left' },
  { name: 'name', label: 'Perfil', field: row => row.perfil, align: 'left' },
  { name: 'format', label: 'Telas', field: row => formatTelasCadastradas(row.telasCadastradas), align: 'left' },
  { name: 'startDate', label: 'Início', field: row => formatDateBr(row.dtIniVigencia), align: 'left' },
  { name: 'endDate', label: 'Fim', field: row => formatDateBr(row.dtFimVigencia), align: 'left' },
  { name: 'status', label: 'Status', field: 'status', align: 'center' },
  { name: 'statusIcon', label: '', field: 'statusIcon', align: 'center' },
  { name: 'acoes', label: 'Ações', field: 'acoes', align: 'center' }
]

const formatTelasCadastradas = (telasCadastradas: string) => {
  if (!telasCadastradas) return '-'

  const map: Record<string, string> = {
    'INICIAL': 'Telas Iniciais',
    'AGUARDE': 'Telas de Aguarde',
    'ABERTURA': 'Tela de Abertura'
  }

  return telasCadastradas
    .split(',')
    .map(t => map[t.trim()] ?? t.trim())
    .join(', ')
}


const qTableCampanhasVisibleColumns = [
  'advertiser',
  'name',
  'format',
  'startDate',
  'endDate',
  'status',
  'statusIcon',
  'acoes'
];

/* =====================
 * ACTIONS
 * ===================== */
const onFilterBtnClick = () => {
  pagesUtilStore.showModalFilterInstitutional = true;
};

const onNewInstitutionalBtnClick = () => {
  router.push({ name: EnumRouteNames.INSTITUTIONAL_NEW });
  institutionalStore.resetState();
};

/* =====================
 * FILTERED DATA
 * ===================== */
const fetchedInstitutionalsFiltered = computed(() => {
  if (!filterTerms.value) {
    return institutionalStore.institutionalScreens;
  }

  const term = filterTerms.value.toLowerCase();

  return institutionalStore.institutionalScreens.filter(item =>
    item.nome?.toLowerCase().includes(term) ||
    item.perfil?.toLowerCase().includes(term)
  );
});

/* =====================
 * STATUS LABEL
 * ===================== */
const getStatusLabel = (statusId: number) => {
  switch (statusId) {
    case CONST_INSTITUTIONAL_STATUS.HISTORICO.id:
      return 'Histórico'
    case CONST_INSTITUTIONAL_STATUS.DRAFT.id:
      return 'Rascunho'
    case CONST_INSTITUTIONAL_STATUS.ON_EDITING.id:
      return 'Em Edição'
    case CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id:
      return 'Em Aprovação'
    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id:
      return 'Ajuste Solicitado'
    case CONST_INSTITUTIONAL_STATUS.APPROVED.id:
      return 'Aprovado'
    case CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id:
      return 'Pendente Publicação'
    case CONST_INSTITUTIONAL_STATUS.PUBLISHED.id:
      return 'Publicado'
    case CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id:
      return 'Ativo'
    case CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id:
      return 'Em Reedição'
    case CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id:
      return 'Em Reaprovação'
    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id:
      return 'Reajuste Solicitado'
    case CONST_INSTITUTIONAL_STATUS.REAPPROVED.id:
      return 'Reaprovado'
    case CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id:
      return 'Concluído'
    case CONST_INSTITUTIONAL_STATUS.CANCELED.id:
      return 'Cancelado'
    default:
      return '-'
  }
}


const statusTextCssClass = (statusId: number) => {
  switch (statusId) {
    case CONST_INSTITUTIONAL_STATUS.HISTORICO.id:
      return 'status-historico'

    case CONST_INSTITUTIONAL_STATUS.APPROVED.id:
      return 'status-approved'

    case CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id:
      return 'status-approving'

    case CONST_INSTITUTIONAL_STATUS.CANCELED.id:
      return 'status-canceled'

    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id:
      return 'status-adjustments-requested'

    case CONST_INSTITUTIONAL_STATUS.ON_EDITING.id:
      return 'status-on-editing'

    case CONST_INSTITUTIONAL_STATUS.DRAFT.id:
      return 'status-draft'

    case CONST_INSTITUTIONAL_STATUS.PUBLISHED.id:
      return 'status-published'

    case CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id:
      return 'status-adjustments-requested'

    case CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id:
      return 'status-approved'

    case CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id:
      return ''

    case CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id:
      return 'status-on-editing'

    case CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id:
      return 'status-approving'

    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id:
      return 'status-adjustments-requested'

    case CONST_INSTITUTIONAL_STATUS.REAPPROVED.id:
      return 'status-approved'

    default:
      return ''
  }
}




/* =====================
 * LIFECYCLE
 * ===================== */
onMounted(async () => {
  institutionalStore.resetInstitutionalFilter();
  await institutionalStore.fetchInstitutionalScreens();
  console.log('Total:', institutionalStore.institutionalScreens.length)
});

/* =====================
 * PERMISSÕES
 * ===================== */
const canEditInstitutional = (row: any) => {
  return (
    authStore.currentUserCanEditInstitutional &&
    [
      CONST_INSTITUTIONAL_STATUS.DRAFT.id,
      CONST_INSTITUTIONAL_STATUS.ON_EDITING.id
    ].includes(row.status)
  )
}

const canDeleteInstitutional = (row: any) => {
  return (
    authStore.currentUserCanDeleteInstitutional &&
    [
      CONST_INSTITUTIONAL_STATUS.DRAFT.id,
      CONST_INSTITUTIONAL_STATUS.CANCELED.id,
      CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id,
      CONST_INSTITUTIONAL_STATUS.HISTORICO.id,
    ].includes(Number(row.status)) // ✅ converte para number
  )
}


const canReviewInstitutional = (row: any) => {
  return (
    authStore.currentUserCanReviewInstitutional &&
    row.status === CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id
  )
}

/* =====================
 * PAGINAÇÃO
 * ===================== */
const pagination = ref({
  page: 1,
  rowsPerPage: 10,
  sortBy: null,
  descending: false
})


</script>

<style scoped>
#btn-show-filterbox {
   margin-right: -11px;
   height: 97%;
   border-left: 1px solid rgb(186, 186, 186);
}

.div-container-action-icons {
  display: flex;
  /* padding-top: 6px; */
  justify-content: center;
  align-items: center;
}


.status-historico {
  color: var(--globalHistorico) !important;
}

.status-approved {
  color: var(--globalSuccessMsgColor) !important;
}

.status-approving {
  color: var(--globalAppSecondaryColor1) !important;
}

.status-canceled {
  color: var(--globalErrorMsgColor) !important;
}

.status-adjustments-requested {
  color: var(--globalWarningMsgColor) !important;
}

.status-on-editing {
  color: var(--globalAppSecondaryColor6	) !important;
}

.status-draft {
  color: var(--globalAppSecondaryColor7) !important;
}

.status-published {
  color: var(--globalAppSecondaryColor8) !important;
}

.label-status {
  padding-left: 30px;
}
</style>